import React, { Key, useEffect, useRef, useState } from 'react';
import frogImageSrc from './assets/frog.png'; // Import the frog image from the assets folder
import handImageSrc from './assets/hand.png';
import swampImageSrc from './assets/swamp.jpg';
import puddleImageSrc from './assets/puddle.png';
import waterSplashImageSrc from './assets/waterSplash.gif';
import splashSound from './assets/splash.mp3';
import kemtapi from 'skeleton-api';
import { Keypoints } from  'skeleton-api';
import {bones} from './utils/drawingFunctions'
import { drawPoints, drawBone, drawFrogHead, drawHandsAndLegs } from './utils/drawingFunctions'



const Skeleton: React.FC<{}> = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const faceCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const frogImageRef = useRef<HTMLImageElement | null>(null);
  const handImageRef = useRef<HTMLImageElement | null>(null);
  const swampImageRef = useRef<HTMLImageElement | null>(null);
  const puddleImageRef = useRef<HTMLImageElement | null>(null);
  const puddleCenterRef = useRef<{ x: number; y: number }>({ x: 0, y: 0 });
  const [splashPos, setSplashPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
  const puddleVisibleRef = useRef(true);
  const puddleCooldownRef = useRef(false); 


  const smoothedFaceRef = useRef({
    centerX: 0,
    centerY: 0,
    scale: 1,
    initialized: false,
  });

  const [showSplash, setShowSplash] = useState(false);

  const updateSkeleton = (kp:Keypoints|null, img : ImageBitmap|ImageData|null) => {
    if (canvasRef.current) {
        drawFrame(canvasRef.current, kp);
    }
  }


  const init = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
    videoRef.current = document.createElement("video");
    videoRef.current.srcObject = stream;
    await videoRef.current.play();
    kemtapi.setInputVideoStream(stream)
    await kemtapi.loadModels()
    const disposer = kemtapi.registerFrameSkeletonCallback(updateSkeleton, "DrawSkeleton");
    return () => {
        disposer();
    }
}

useEffect(() => {
    init();    
}, []);





  // Define the connections between points
  const connections = [
    ["top_of_the_head", "nose"],
    ["nose", "chin"],
    ["chin", "neck"],
    ["neck", "left_shoulder"],
    ["neck", "right_shoulder"],
    ["left_shoulder", "left_elbow"],
    ["left_elbow", "left_wrist"],
    ["right_shoulder", "right_elbow"],
    ["right_elbow", "right_wrist"],
    ["neck", "front_1"],
    ["front_1", "front_2"],
    ["front_2", "front_3"],
    ["front_3", "front_4"],
    ["front_4", "front_5"],
    ["left_hip", "front_5"],
    ["right_hip", "front_5"],
    ["left_hip", "left_knee"],
    ["left_knee", "left_ankle"],
    ["right_hip", "right_knee"],
    ["right_knee", "right_ankle"],
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    const frogImage = new Image();
    const handImage = new Image();
    const backgroundImage = new Image();
    const puddleImage = new Image();
    frogImage.src = frogImageSrc; // Use the imported frog image
    handImage.src = handImageSrc;
    backgroundImage.src = swampImageSrc;
    puddleImage.src = puddleImageSrc;


    frogImage.onload = () => {
      frogImageRef.current = frogImage; // Store the loaded image
      handImageRef.current = handImage;
      swampImageRef.current = backgroundImage;
      puddleImageRef.current = puddleImage;

    };
  }, []);


const drawFrame = (
  //context: CanvasRenderingContext2D,
  canvas: HTMLCanvasElement,
  frame: Keypoints
) => {

    const context = canvas.getContext('2d');
    if (!context) return;

  context.clearRect(0, 0, context.canvas.width, context.canvas.height);

  // Draw background and puddle only if visible
  drawBackground(context);

  if (!frame) return;

  drawPoints(context, frame);
  
  for (const bone of bones) {
  drawBone(context, frame, bone, "#00FF00");
  }
  //drawConnections(context, frame);
  drawFrogHead(context, frame, frogImageRef.current);


  drawHandsAndLegs(context, frame,handImageRef.current );

  if (videoRef.current) {
    drawFaceCanvas(frame, videoRef.current);
  }

  const leftAnkle = frame.get("left_ankle");
  const rightAnkle = frame.get("right_ankle");

  if (!puddleCooldownRef.current) {
    if (!leftAnkle || !rightAnkle) {
      puddleVisibleRef.current = false;
    } else if (leftAnkle.y > 380 || rightAnkle.y > 380) {
      puddleVisibleRef.current = false;
    } else {
      puddleVisibleRef.current = true;
    }
  }


  

  // Check for collision only if balloon is visible
  if (puddleVisibleRef.current) {
    const leftToe = frame.get("left_bigtoe");
    const rightToe = frame.get("right_bigtoe");
    const leftAnkle = frame.get("left_ankle");
    const rightAnkle = frame.get("right_ankle");
    const leftMiddleFinger = frame.get("left_middle_finger1");
    const rightMiddleFinger = frame.get("right_middle_finger1");

    const organsToCheck = [leftToe, rightToe, leftAnkle, rightAnkle, leftMiddleFinger, rightMiddleFinger];

    for (const organ of organsToCheck) {
      if (organ && organ.x >= 0 && organ.y >= 0) {
        //const [x, y] = finger;
        if (isTouchingPuddle(organ.x, organ.y)) {
          puddleVisibleRef.current = false; // Hide the puddle
          puddleCooldownRef.current = true;

          const audio = new Audio(splashSound);
          audio.play();


          const canvas = canvasRef.current;
          if (canvas) {
            const bounds = canvas.getBoundingClientRect();
            const scaleX = bounds.width / canvas.width;
            const scaleY = bounds.height / canvas.height;

            const splashLeft = bounds.left + puddleCenterRef.current.x * scaleX;
            const splashTop = bounds.top + puddleCenterRef.current.y * scaleY - 30;

            setSplashPos({ top: splashTop, left: splashLeft });
          }

          setShowSplash(true);
          setTimeout(() => setShowSplash(false), 1000);


          setTimeout(() => {
            puddleCooldownRef.current = false;
          }, 3000);

          break;
        }
      }
    }
  }
    
};

const drawFaceCanvas = (frame: Keypoints, video: HTMLVideoElement) => {
    const ctx = faceCanvasRef.current?.getContext("2d");
    if (!ctx || !faceCanvasRef.current) return;

    const topHead = frame.get("top_of_the_head");
    const neck = frame.get("neck");
    const leftEye = frame.get("left_eye");
    const rightEye = frame.get("right_eye");

    if (!topHead || !neck || !leftEye || !rightEye) return;

    const currentFaceHeight = Math.abs(neck.y - topHead.y);
    if (currentFaceHeight < 1) return;

    const rawCenterX = (leftEye.x + rightEye.x) / 2;
    const rawCenterY = topHead.y + currentFaceHeight * 0.45;
    const targetFaceHeight = 120;
    const rawScale = (currentFaceHeight / targetFaceHeight) * 1;

    const smoothingFactor = 0.2;
    if (!smoothedFaceRef.current.initialized) {
      smoothedFaceRef.current = {
        centerX: rawCenterX,
        centerY: rawCenterY,
        scale: rawScale,
        initialized: true,
      };
    } else {
      smoothedFaceRef.current.centerX =
        smoothedFaceRef.current.centerX * (1 - smoothingFactor) + rawCenterX * smoothingFactor;
      smoothedFaceRef.current.centerY =
        smoothedFaceRef.current.centerY * (1 - smoothingFactor) + rawCenterY * smoothingFactor;
      smoothedFaceRef.current.scale =
        smoothedFaceRef.current.scale * (1 - smoothingFactor) + rawScale * smoothingFactor;
    }

    const centerX = smoothedFaceRef.current.centerX;
    const centerY = smoothedFaceRef.current.centerY;
    const scale = smoothedFaceRef.current.scale;

    const outputW = 180;
    const outputH = 250;
    const cropW = outputW * scale * 0.5;
    const cropH = outputH * scale * 0.5;
    const cropX = Math.max(0, centerX - cropW / 2);
    const cropY = Math.max(0, centerY - cropH / 2);

    ctx.clearRect(0, 0, faceCanvasRef.current.width, faceCanvasRef.current.height);

    ctx.save();
    ctx.beginPath();
    ctx.ellipse(outputW / 2, outputH / 2, outputW / 2, outputH / 2, 0, 0, Math.PI * 2);
    ctx.clip();

    ctx.drawImage(video, cropX, cropY, cropW, cropH, 0, 0, outputW, outputH);
    ctx.restore();
  };



const drawBackground = (context: CanvasRenderingContext2D) => {
  const bgImage = swampImageRef.current;
  const puddleImage = puddleImageRef.current;

  if (bgImage) {
    context.drawImage(bgImage, 0, 0, context.canvas.width, context.canvas.height);
  }

  if (puddleImage && puddleVisibleRef.current) {
    const canvasWidth = context.canvas.width;
    const canvasHeight = context.canvas.height;
    const puddleWidth = 200;
    const puddleHeight = 100;
    const x = (canvasWidth - puddleWidth) / 2;
    const y = (canvasHeight - puddleHeight) / 2 + 190;

    puddleCenterRef.current = {
      x: x + puddleWidth / 2,
      y: y + puddleHeight / 2,
    };

    context.drawImage(puddleImage, x, y, puddleWidth, puddleHeight);
  }
};

const isTouchingPuddle = (x: number, y: number): boolean => {
  const canvas = canvasRef.current;
  if (!canvas) return false;

  const canvasWidth = canvas.width;
  const canvasHeight = canvas.height;

  const puddleWidth = 200;
  const puddleHeight = 100;

  // Position it in the center horizontally and lower vertically (same as your draw code)
  const puddleX = (canvasWidth - puddleWidth) / 2;
  const puddleY = (canvasHeight - puddleHeight) / 2 + 190;

  // Check if the point (x, y) is inside the rectangle
  return (
    x >= puddleX &&
    x <= puddleX + puddleWidth &&
    y >= puddleY &&
    y <= puddleY + puddleHeight
  );
};



// const drawPoints = (
//   context: CanvasRenderingContext2D,
//   frame: Keypoints|null
// ) => {
//     if (!frame) return  ;

//   context.fillStyle = 'red'; // Set point color
//   for (let key of frame.points()) {
//     const point = frame.get(key);
//     if (!point) continue;
    
//     if (point) {
//       if (point.x >= 0 && point.y >= 0) {
//         context.beginPath();
//         context.arc(point.x, point.y, 5, 0, 2 * Math.PI); // Draw a circle for each point
//         context.fill();
//       }
//     }
//   }
// };

// const drawConnections = (
//   context: CanvasRenderingContext2D,
//   frame: Keypoints|null
// ) => {
//     if (!frame) return;
//   // Draw connections
//   context.strokeStyle = 'blue'; // Set line color
//   context.lineWidth = 2; // Set line width
//   for (const [start, end] of connections) {
//     const startPoint = frame.get(start);
//     const endPoint = frame.get(end);
    
//     if (
//       startPoint &&
//       endPoint &&
//       startPoint.x >= 0 &&
//       startPoint.y >= 0 &&
//       endPoint.x >= 0 &&
//       endPoint.y >= 0
//     ) {
//       context.beginPath();
//       context.moveTo(startPoint.x, startPoint.y); // Move to the starting point
//       context.lineTo(endPoint.x, endPoint.y); // Draw a line to the endpoint
//       context.stroke(); // Render the line
//     }
//   }
// }

// const drawFrogHead = (
//   context: CanvasRenderingContext2D,
//   frame: Keypoints|null
// ) => {
//   if (!frame) return;

//   const nose = frame.get("nose");
//     const topOfTheHead = frame.get("top_of_the_head");
//     const image = frogImageRef.current;

//     if (
//       nose &&
//       topOfTheHead &&
//       //nose.length === 2 &&
//       //topOfTheHead.length === 2 &&
//       image
//     ) {
//       //const [noseX, noseY] = nose;
//       //const [headX, headY] = topOfTheHead;

//       const dist = Math.sqrt((nose.x-topOfTheHead.x) **2 + (nose.y-topOfTheHead.y) **2);

//       // Calculate the angle between "nose" and "top_of_the_head"
//       const angle = Math.atan2(topOfTheHead.y - nose.y, topOfTheHead.x - nose.x);
//       //console.log( "frame " + frameIndex + " angle " + angle);

//       // Set image size
//       const imageWidth = dist*2;
//       const imageHeight = dist*2;
      

//       // Rotate and draw the image
//       context.save(); // Save the current canvas state
//       context.translate(nose.x, nose.y); // Move the canvas origin to the "nose" position
//       context.rotate(angle + Math.PI / 2); // Rotate the canvas (add 90 degrees to align the image vertically)
//       context.drawImage(
//         image,
//         -imageWidth / 2, // Center the image
//         -imageHeight / 2,
//         imageWidth,
//         imageHeight
//       );
//       context.restore(); // Restore the canvas state
//     }
// }

// const drawHandsAndLegs = (
//   context: CanvasRenderingContext2D,
//   frame: Keypoints
//   //frameIndex: number
// ) => {
//   // Draw the hand image at specific points
// const handConnections = [
//   ["left_wrist", "left_middle_finger1"],
//   ["right_wrist", "right_middle_finger1"],
//   ["left_ankle", "left_bigtoe"],
//   ["right_ankle", "right_bigtoe"],
// ];
// const handImage = handImageRef.current;

// const nose = frame.get("nose");
// const head = frame.get("top_of_the_head");

// if (!nose || !head) return;
// const dist = Math.sqrt((nose.x-head.x) **2 + (nose.y-head.y) **2);

// if (handImage) {
//   const imageSize = dist*(2/3); // Set hand image size
//   for (const [start, end] of handConnections) {
//     console.log("drawHandsAndLegs start " + start + " end " + end);

//     let startPoint = frame.get(start);
//     let endPoint = frame.get(end);
    
//     // If both points are valid, draw the hand image

//     if (!startPoint || !endPoint) continue;

//     // Calculate the angle between the points
//     const angle = Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x);
      
//     //console.log( "frame " + frameIndex + " angle " + angle + " start " + x1 + " , " + y1  +" end " + x2 +" , " + y2);
      
//     // Rotate and draw the hand image
//     context.save();
//     context.translate(startPoint.x, startPoint.y); // Move canvas origin to the start point
//     context.rotate(angle + Math.PI / 2); // Rotate canvas
//     // Adjust the image position so that the bottom aligns with the wrist
//     const adjustedX = -imageSize / 2; // Center the image horizontally
//     const adjustedY = -imageSize; // Align the bottom of the image with the wrist

//     context.drawImage(handImage, adjustedX, adjustedY, imageSize, imageSize);
//     context.restore();
    
//   }
// }
// };



return (
  <div style={{ width: "78vw", height: "99vh", margin: 0, padding: 0, overflow: "hidden", position: "relative" }}>
      <canvas
        ref={canvasRef}
        width={640}
        height={480}
        style={{
          width: "100%",
          height: "100%",
          transform: "scaleX(-1)",
          display: "block",
        }}
    />

    <canvas
      ref={faceCanvasRef}
      width={180}
      height={250}
      style={{
        position: 'fixed',
        right: '105px',
        top: '550px',
        zIndex: 10,
        borderRadius: '50%',
        overflow: 'hidden',
      }}
    />

    {showSplash && (
      <img
        src={waterSplashImageSrc}
        alt="Water Splash"
        style={{
          position: 'fixed', // use fixed for screen-space accuracy
          top: `${splashPos.top}px`,
          left: `${splashPos.left}px`,
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          width: '300px',
          height: '300px',
          pointerEvents: 'none',
        }}
      />
    )}
  </div>
);


};

export default Skeleton;